export const ANIM_TRANSFORM = 'translate(0, -75vh)';
export const TRANSITION_DURATION = 500;
